import { SVGAttributes } from 'react'

export default function KittingIcon(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
			<path d="M28 56c15.464 0 28-12.536 28-28S43.464 0 28 0 0 12.536 0 28s12.536 28 28 28z" fill="#363940"/>
			<path d="M42.635 44.501L28 49.02 13.366 44.5V30.352L28 34.907l14.635-4.555v14.15z" fill="#C6C8CF"/>
			<path d="M28 34.907l-7.84 2.464-14.634-4.555 7.84-2.464L28 34.907zM28 34.907l7.84 2.464 14.635-4.555-7.84-2.464L28 34.907z" fill="#fff"/>
			<path d="M28 25.835l-7.84-2.464-14.634 4.554 7.84 2.427L28 25.835zM28 25.835l7.84-2.464 14.635 4.554-7.84 2.427L28 25.835z" fill="#fff"/>
			<path d="M14.299 30.352L28 26.133l13.702 4.219L28 34.608 14.3 30.352z" fill="#C6C8CF"/>
			<path d="M28 26.395l12.731 3.957-12.73 3.957-12.731-3.957L28 26.395zm0-.56l-14.634 4.517L28 34.907l14.635-4.555L28 25.834z" fill="#363940"/>
			<path d="M35.84 37.93L28 35.505l-7.84 2.427h-.074L5.414 33.376l.186-.56 14.56 4.517L28 34.907l7.84 2.426 14.56-4.517.187.56L35.84 37.93z" fill="#363940"/>
			<path d="M29.27 9.744h-2.502v6.272h2.501V9.744z" fill="#8DC63F"/>
			<path d="M24.752 15.082l3.248 5.6 3.248-5.6h-6.496zM43.867 10.468l-4.435 4.435 1.768 1.769 4.435-4.435-1.768-1.769z" fill="#8DC63F"/>
			<path d="M38.677 12.805l-1.68 6.272 6.272-1.68-4.592-4.592zM12.126 10.461l-1.769 1.77 4.435 4.434 1.769-1.768-4.435-4.436z" fill="#8DC63F"/>
			<path d="M12.73 17.397l6.273 1.68-1.68-6.272-4.593 4.592z" fill="#8DC63F"/>
		</svg>
	)
}


